"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentEnergyLabelAndIndex = exports.averageEnergyIndices = exports.getPreliminaryEnergyLabel = exports.getEnergyLabel = void 0;
const constants_1 = require("./constants");
const getEnergyLabel = (energyIndex) => {
    switch (true) {
        case energyIndex <= constants_1.constants.energyLabels['A++']:
            return 'A++';
        case energyIndex <= constants_1.constants.energyLabels['A+']:
            return 'A+';
        case energyIndex <= constants_1.constants.energyLabels.A:
            return 'A';
        case energyIndex <= constants_1.constants.energyLabels.B:
            return 'B';
        case energyIndex <= constants_1.constants.energyLabels.C:
            return 'C';
        case energyIndex <= constants_1.constants.energyLabels.D:
            return 'D';
        case energyIndex <= constants_1.constants.energyLabels.E:
            return 'E';
        case energyIndex <= constants_1.constants.energyLabels.F:
            return 'F';
        default:
            return 'G';
    }
};
exports.getEnergyLabel = getEnergyLabel;
function getPreliminaryEnergyLabel(type, year) {
    let labels = ['G', 'F', 'D', 'C', 'C', 'C', 'B', 'A', 'A'];
    // Vrijstaande woning
    if (type === 1)
        labels = ['G', 'F', 'D', 'C', 'C', 'B', 'B', 'A', 'A'];
    // Twee-onder-één-kapwoning
    if (type === 2)
        labels = ['G', 'F', 'D', 'C', 'C', 'B', 'B', 'B', 'A'];
    // Hoekwoning
    if (type === 3)
        labels = ['G', 'F', 'D', 'C', 'C', 'C', 'B', 'A', 'A'];
    // Tussenwoning
    if (type === 4)
        labels = ['F', 'E', 'C', 'C', 'C', 'C', 'B', 'A', 'A'];
    // Generiek appartement
    if (type === 5)
        labels = ['G', 'E', 'F', 'C', 'C', 'C', 'B', 'B', 'A'];
    // Maisonette hoek dak vloer
    if (type === 6)
        labels = ['G', 'E', 'D', 'C', 'C', 'B', 'A', 'A', 'A'];
    // Maisonette hoek dak
    if (type === 7)
        labels = ['G', 'E', 'C', 'B', 'C', 'B', 'A', 'A', 'A'];
    // Maisonette hoek vloer
    if (type === 8)
        labels = ['E', 'D', 'C', 'C', 'C', 'C', 'A', 'A', 'A'];
    // Maisonette hoek midden
    if (type === 9)
        labels = ['E', 'D', 'C', 'B', 'C', 'C', 'A', 'A', 'A'];
    // Maisonette tussen dak vloer
    if (type === 10)
        labels = ['F', 'E', 'C', 'B', 'C', 'B', 'A', 'A', 'A'];
    // Maisonette tussen dak
    if (type === 11)
        labels = ['F', 'E', 'C', 'B', 'C', 'B', 'A', 'A', 'A'];
    // Maisonette tussen vloer
    if (type === 12)
        labels = ['D', 'D', 'C', 'B', 'C', 'C', 'A', 'A', 'A'];
    // Maisonette tussen midden
    if (type === 13)
        labels = ['D', 'D', 'C', 'B', 'C', 'C', 'A', 'A', 'A'];
    // Appartement hoek dak vloer
    if (type === 14)
        labels = ['G', 'G', 'F', 'C', 'C', 'C', 'B', 'B', 'A'];
    // Appartement hoek dak
    if (type === 15)
        labels = ['G', 'G', 'F', 'C', 'C', 'C', 'B', 'B', 'A'];
    // Appartement hoek vloer
    if (type === 16)
        labels = ['G', 'E', 'F', 'C', 'C', 'C', 'B', 'B', 'A'];
    // Appartement hoek midden
    if (type === 17)
        labels = ['G', 'E', 'F', 'C', 'C', 'C', 'B', 'B', 'A'];
    // Appartement tussen dak vloer
    if (type === 18)
        labels = ['G', 'F', 'F', 'C', 'C', 'C', 'B', 'A', 'A'];
    // Appartement tussen dak
    if (type === 19)
        labels = ['G', 'G', 'F', 'C', 'C', 'C', 'B', 'B', 'A'];
    // Appartement tussen vloer
    if (type === 20)
        labels = ['G', 'E', 'E', 'B', 'C', 'C', 'B', 'B', 'A'];
    // Appartement tussen midden
    if (type === 21)
        labels = ['G', 'E', 'F', 'C', 'C', 'C', 'B', 'B', 'A'];
    // Schakelwoning
    if (type === 22)
        labels = ['G', 'F', 'D', 'C', 'C', 'B', 'B', 'B', 'A'];
    if (year <= 1945)
        return labels[0];
    if (year > 1945 && year <= 1964)
        return labels[1];
    if (year > 1964 && year <= 1974)
        return labels[2];
    if (year > 1974 && year <= 1982)
        return labels[3];
    if (year > 1982 && year <= 1987)
        return labels[4];
    if (year > 1987 && year <= 1991)
        return labels[5];
    if (year > 1991 && year <= 1999)
        return labels[6];
    if (year > 1999 && year <= 2005)
        return labels[7];
    if (year > 2005)
        return labels[8];
    return 'G';
}
exports.getPreliminaryEnergyLabel = getPreliminaryEnergyLabel;
exports.averageEnergyIndices = {
    'A++++': 0.2,
    'A+++': 0.35,
    'A++': 0.5,
    'A+': 0.7,
    A: 1,
    B: 1.3,
    C: 1.6,
    D: 1.95,
    E: 2.25,
    F: 2.55,
    G: 2.75,
};
function getCurrentEnergyLabelAndIndex(houseEI, type, constructionYear, labelRegistration) {
    const estimatedLabel = (0, exports.getEnergyLabel)(houseEI);
    const preliminaryLabel = getPreliminaryEnergyLabel(type, constructionYear);
    let currentEnergyLabel = preliminaryLabel < estimatedLabel ? preliminaryLabel : estimatedLabel;
    let currentEnergyIndex = preliminaryLabel < estimatedLabel ? exports.averageEnergyIndices[preliminaryLabel] : houseEI;
    if (labelRegistration?.energyIndex) {
        currentEnergyLabel = (0, exports.getEnergyLabel)(labelRegistration.energyIndex);
        currentEnergyIndex = labelRegistration.energyIndex;
    }
    else if (labelRegistration?.energyLabel) {
        currentEnergyLabel = labelRegistration?.energyLabel;
        currentEnergyIndex = exports.averageEnergyIndices[labelRegistration?.energyLabel];
    }
    return { currentEnergyLabel, currentEnergyIndex };
}
exports.getCurrentEnergyLabelAndIndex = getCurrentEnergyLabelAndIndex;
